/**
 * Copyright (c) 2022 - Present. Blend Labs, Inc. All rights reserved
 * Blend Confidential - Restricted
 */
import styled from 'styled-components';
import { Box, Header, Heading } from 'grommet';
import { useThemeColor as c } from '@blend/alchemy';
import * as React from 'react';

const StyledHeader = styled(Header)`
  background-color: ${c('cloud10')};
  padding: 42px 40px 12px;
`;

export namespace PageHeader {
  export interface Props {
    actions: React.ReactFragment;
    title: string;
  }
}

export const PageHeader = ({ title, actions }: PageHeader.Props) => {
  return (
    <StyledHeader>
      <Heading level={2}>{title}</Heading>
      <Box>{actions}</Box>
    </StyledHeader>
  );
};
